// export const HOST = process.env.REACT_APP_API_HOST || 'http://localhost:8000';
export const HOST = process.env.REACT_APP_API_HOST || 'https://lc.voxastro.org/api';
export const FULU_URL = process.env.REACT_APP_FULU_URL || 'https://lc-dev.voxastro.org/fulu.html';

